import { render, staticRenderFns } from "./MinoreCalendar.vue?vue&type=template&id=62561f1d"
import script from "./MinoreCalendar.vue?vue&type=script&lang=js"
export * from "./MinoreCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports